import React, {
    useState, useEffect
} from 'react';

import {
    BookOpen, Calendar, CloudRain, Thermometer, Users, Hammer, List, PlusCircle, Trash2, Download, ClipboardList, Filter, Cctv, X, Image as ImageIcon, AlertTriangle, Info
} from 'lucide-react';

import axios from 'axios';
import { formatImageUrl } from '../utils/urlHelper';

import {
    jsPDF
} from 'jspdf';

import autoTable from 'jspdf-autotable';
import { openDB } from 'idb';

// Helper de IndexedDB
const initDB = async () => {
    return openDB('archi24_7_offline_db', 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains('pending_logs')) {
                db.createObjectStore('pending_logs', { keyPath: 'id', autoIncrement: true });
            }
        },
    });
};
const Bitacora = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState('list');
    // 'list' or 'form'
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const activeProjectName = localStorage.getItem('activeProjectName') || 'Proyecto Sin Asignar';
    const role = localStorage.getItem('userRole');
    const [logoUrl, setLogoUrl] = useState(null);

    useEffect(() => {
        const fetchProjectLogo = async () => {
            const token = localStorage.getItem('token');
            const activeProjectId = localStorage.getItem('activeProjectId');
            if (!token || !activeProjectId) return;
            try {
                const res = await axios.get('http://localhost:4000/api/projects', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const activeProj = res.data.find(p => p.id === parseInt(activeProjectId));
                if (activeProj && activeProj.logo_url) {
                    setLogoUrl(activeProj.logo_url);
                }
            } catch (err) {
                console.error("Error al obtener logotipo del proyecto en Bitacora:", err);
            }
        };
        fetchProjectLogo();
    }, []);
    const [formData, setFormData] = useState({
        log_date: new Date().toISOString().split('T')[0], weather_conditions: 'Soleado', temperature: '', personnel_count: 0, activities_description: '', equipment_used: '', incidents_comments: ''
    });
    const [photos, setPhotos] = useState([]);
    const [photoPreviews, setPhotoPreviews] = useState([]);
    const [isOffline, setIsOffline] = useState(!navigator.onLine);
    const [pendingCount, setPendingCount] = useState(0);

    const checkPendingLogs = async () => {
        try {
            const db = await initDB();
            const tx = db.transaction('pending_logs', 'readonly');
            const store = tx.objectStore('pending_logs');
            const logs = await store.getAll();
            setPendingCount(logs.length);
        } catch (e) {
            console.error("Error checks pending", e);
        }
    };

    const syncOfflineLogs = async () => {
        if (!navigator.onLine) return;
        try {
            const db = await initDB();
            const tx = db.transaction('pending_logs', 'readonly');
            const store = tx.objectStore('pending_logs');
            const pendingLogs = await store.getAll();

            if (pendingLogs.length === 0) return;

            for (const item of pendingLogs) {
                const data = new FormData();
                Object.keys(item.formData).forEach(key => data.append(key, item.formData[key]));
                if (item.photos && item.photos.length > 0) {
                    for (const photoData of item.photos) {
                        const response = await fetch(photoData.dataUrl);
                        const blob = await response.blob();
                        const file = new File([blob], photoData.name, { type: photoData.type });
                        data.append('photos', file);
                    }
                }

                await axios.post('http://localhost:4000/api/logs', data, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'x-project-id': localStorage.getItem('activeProjectId'),
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            const clearTx = db.transaction('pending_logs', 'readwrite');
            await clearTx.objectStore('pending_logs').clear();
            setPendingCount(0);
            fetchLogs();
            alert(`Sincronización exitosa: Se subieron ${pendingLogs.length} reportes guardados offline.`);
        } catch (err) {
            console.error('Error sincronizando offline logs', err);
        }
    };

    useEffect(() => {
        const handleOnline = () => {
            setIsOffline(false);
            syncOfflineLogs();
        };
        const handleOffline = () => setIsOffline(true);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        checkPendingLogs();

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        fetchLogs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate]);
    const fetchLogs = async () => {
        try {
            setLoading(true);
            let url = 'http://localhost:4000/api/logs';
            const params = [];
            if (startDate) params.push(`startDate=${startDate
                }`);
            if (endDate) params.push(`endDate=${endDate
                }`);
            if (params.length > 0) url += `?${params.join('&')
                }`;
            const res = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')
                        }`, 'x-project-id': localStorage.getItem('activeProjectId')
                }
            });
            setLogs(res.data);
        } catch (err) {
            console.error("Error cargando bitácoras:", err);
        } finally {
            setLoading(false);
        }
    };
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };
    const handlePhotoChange = (e) => {
        if (e.target.files) {
            const filesArray = Array.from(e.target.files).slice(0, 5);
            // Max 5 fotos setPhotos(filesArray);
            // Generar URLs para previsualización
            const previews = filesArray.map(file => URL.createObjectURL(file));
            setPhotoPreviews(previews);
        }
    };
    const removePhoto = (index) => {
        const newPhotos = [...photos];
        newPhotos.splice(index, 1);
        setPhotos(newPhotos);
        const newPreviews = [...photoPreviews];
        newPreviews.splice(index, 1);
        setPhotoPreviews(newPreviews);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (isOffline) {
                // Guardar localmente
                const db = await initDB();
                const tx = db.transaction('pending_logs', 'readwrite');

                // Convert files to base64
                const photoPromises = photos.map(file => {
                    return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve({ name: file.name, type: file.type, dataUrl: reader.result });
                        reader.readAsDataURL(file);
                    });
                });

                const base64Photos = await Promise.all(photoPromises);

                await tx.objectStore('pending_logs').add({
                    formData: { ...formData },
                    photos: base64Photos,
                    timestamp: Date.now()
                });

                alert("Sin conexión: Bitácora guardada localmente. Se sincronizará automáticamente.");
                checkPendingLogs();
            } else {
                const data = new FormData();
                Object.keys(formData).forEach(key => {
                    data.append(key, formData[key]);
                });
                photos.forEach(file => {
                    data.append('photos', file);
                });
                await axios.post('http://localhost:4000/api/logs', data, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'x-project-id': localStorage.getItem('activeProjectId'),
                        'Content-Type': 'multipart/form-data'
                    }
                });
                fetchLogs();
            }

            setViewMode('list');
            setPhotos([]);
            setPhotoPreviews([]);
            setFormData({
                log_date: new Date().toISOString().split('T')[0], weather_conditions: 'Soleado', temperature: '', personnel_count: 0, activities_description: '', equipment_used: '', incidents_comments: ''
            });
        } catch (error) {
            console.error("Error guardando bitácora:", error);
            alert("Error al guardar el reporte.");
        }
    };
    const handleDelete = async (id) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar esta bitácora permanentemente?")) {
            try {
                await axios.delete(`http://localhost:4000/api/logs/${id
                    }`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        'x-project-id': localStorage.getItem('activeProjectId')
                    }
                });
                setLogs(logs.filter(log => log.id !== id));
            } catch (error) {
                console.error("Error eliminando bitácora:", error);
                alert(error.response?.data?.error || "Error al eliminar");
            }
        }
    };
    const getBase64ImageFromUrl = async (imageUrl) => {
        try {
            const res = await fetch(imageUrl);
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (err) {
            console.error("Error converting logo to base64 for PDF:", err);
            return null;
        }
    };

    const downloadPDF = async (log) => {
        try {
            const doc = new jsPDF();

            // Header
            doc.setFillColor(15, 23, 42); // slate-900
            doc.rect(0, 0, 210, 45, 'F');

            let logoWidth = 0;
            if (logoUrl) {
                try {
                    const base64Logo = await getBase64ImageFromUrl(logoUrl);
                    if (base64Logo) {
                        const format = logoUrl.endsWith('.jpg') || logoUrl.endsWith('.jpeg') ? 'JPEG' : 'PNG';
                        doc.addImage(base64Logo, format, 15, 8, 30, 16);
                        logoWidth = 35;
                    }
                } catch (logoErr) {
                    console.error("Error drawing logo in PDF:", logoErr);
                }
            }

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(26);
            doc.setFont("helvetica", "bold");
            
            const startX = 15 + logoWidth;
            doc.text("Archi24/", startX, 22);

            doc.setTextColor(59, 130, 246);
            doc.text("7", startX + 42, 22);

            doc.setTextColor(200, 200, 200);
            doc.setFontSize(12);
            doc.setFont("helvetica", "normal");
            doc.text("Bitácora de Obra Oficial", startX, 32);

            const reportDate = new Date(log.log_date).toLocaleDateString() || 'N/A';
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.text(`Fecha: ${reportDate}`, 195, 20, { align: 'right' });
            doc.text(`Folio: #${log.id}`, 195, 26, { align: 'right' });

            // Si el proyecto viniera en el objeto (opcional), lo agregamos
            if (log.project_name) {
                doc.text(`Obra: ${log.project_name}`, 195, 32, { align: 'right' });
            }

            let currentY = 55;

            // Datos Generales con autoTable
            autoTable(doc, {
                startY: currentY,
                head: [['Clima', 'Temperatura', 'Fuerza Laboral', 'Elaboró']],
                body: [[
                    log.weather_conditions || 'N/A',
                    log.temperature || 'N/A',
                    log.personnel_count ? `${log.personnel_count} personas` : '0',
                    log.author_name || 'N/A'
                ]],
                theme: 'grid',
                headStyles: { fillColor: [59, 130, 246] },
                margin: { left: 15, right: 15 }
            });

            currentY = doc.lastAutoTable.finalY + 15;

            // Resumen de Ejecución
            doc.setFontSize(14);
            doc.setTextColor(15, 23, 42);
            doc.setFont("helvetica", "bold");
            doc.text("Resumen de Ejecución", 15, currentY);

            currentY += 8;
            doc.setFontSize(11);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(60, 60, 60);

            const activities = doc.splitTextToSize(log.activities_description || 'Sin actividades registradas.', 180);
            doc.text(activities, 15, currentY);
            currentY += (activities.length * 6) + 10;

            // Maquinaria y Logística
            if (log.equipment_used) {
                doc.setFontSize(14);
                doc.setTextColor(15, 23, 42);
                doc.setFont("helvetica", "bold");
                doc.text("Maquinaria y Logística Desplegada", 15, currentY);

                currentY += 8;
                doc.setFontSize(11);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(60, 60, 60);
                const equipment = doc.splitTextToSize(log.equipment_used, 180);
                doc.text(equipment, 15, currentY);
                currentY += (equipment.length * 6) + 10;
            }

            // Observaciones Críticas
            if (log.incidents_comments) {
                doc.setFontSize(14);
                doc.setTextColor(225, 29, 72); // Rose-600
                doc.setFont("helvetica", "bold");
                doc.text("Observaciones Críticas / EHS", 15, currentY);

                currentY += 8;
                doc.setFontSize(11);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(60, 60, 60);
                const incidents = doc.splitTextToSize(log.incidents_comments, 180);
                doc.text(incidents, 15, currentY);
                currentY += (incidents.length * 6) + 15;
            } else {
                currentY += 5;
            }

            // Verificar si necesitamos nueva página para firmas
            if (currentY > 240) {
                doc.addPage();
                currentY = 40;
            } else {
                currentY += 20;
            }

            // Firmas
            doc.setDrawColor(150, 150, 150);
            doc.line(25, currentY, 85, currentY);
            doc.line(125, currentY, 185, currentY);

            doc.setFontSize(10);
            doc.setTextColor(100, 100, 100);
            doc.text("Responsable de Obra", 55, currentY + 6, { align: 'center' });
            doc.text("Supervisión / VOBO", 155, currentY + 6, { align: 'center' });

            doc.save(`Bitacora_${reportDate.replace(/\//g, '-')}_ID${log.id}.pdf`);
        } catch (error) {
            console.error("Error al generar PDF:", error);
            alert("No se pudo generar el documento PDF.");
        }
    };
    if (loading) {
        return (<div className="h-full flex items-center justify-center"> <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div> </div>);
    } return (<div className="p-8 max-w-7xl mx-auto space-y-8 animate-fade-in pb-20 font-sans"> {
        /* Estado de Conexión */
    } {isOffline && (<div className="bg-amber-500/20 border border-amber-500/50 text-amber-500 px-6 py-4 rounded-2xl flex items-center gap-3 font-semibold shadow-lg backdrop-blur-md"> <CloudRain size={24} /> <span>Modo Offline: No hay conexión a internet. Los registros se guardarán localmente en su dispositivo temporalmente.</span> </div>)} {pendingCount > 0 && !isOffline && (<div className="bg-blue-500/20 border border-blue-500/50 text-blue-400 px-6 py-4 rounded-2xl flex items-center justify-between font-semibold shadow-lg backdrop-blur-md"> <div className="flex items-center gap-3"><BookOpen size={24} /> <span>Tienes {pendingCount} reporte(s) guardado(s) localmente listos para subir.</span></div> <button onClick={syncOfflineLogs} className="bg-blue-600 hover:bg-blue-500 text-theme-text-primary px-4 py-2 rounded-xl text-sm transition-all shadow-md">Sincronizar Ahora</button> </div>)} {
            /* Header Presentacional */
        } <div className="bg-theme-panel/50 backdrop-blur-xl border border-theme-border rounded-3xl p-8 relative overflow-hidden group mb-8 flex flex-col md:flex-row justify-between md:items-center gap-6"> <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 to-transparent opacity-50 group-hover:opacity-100 transition-opacity duration-700"></div> <div className="relative z-10 flex items-center gap-4"> <div className="bg-blue-500/10 p-4 rounded-2xl border border-blue-500/20"> <BookOpen className="text-blue-500" size={
            32
        } /> </div> <div> <h1 className="text-3xl font-black text-theme-text-primary tracking-tight mb-1">Bitácora Oficial</h1> <p className="text-theme-text-secondary font-medium">Registro operativo y normativo.</p> </div> </div> <div className="relative z-10 flex gap-3 bg-theme-bg/80 p-1.5 rounded-2xl border border-theme-border shadow-inner">        <button onClick={() => setViewMode('list')} className={`px-5 py-2.5 rounded-xl text-sm font-bold transition-all flex items-center gap-2 ${viewMode === 'list' ? 'bg-gradient-to-br from-blue-600 to-indigo-600 text-theme-text-primary shadow-lg shadow-blue-500/25' : 'text-theme-text-secondary hover:text-theme-text-primary transition-colors'}`}>
            <List size={18} /> Historial
        </button>
        {(role === 'PROJECT_MANAGER' || role === 'SUPER_ADMIN' || role === 'COMPANY_ADMIN') ? (
            <button onClick={() => setViewMode('form')} className={`px-5 py-2.5 rounded-xl text-sm font-bold transition-all flex items-center gap-2 ${viewMode === 'form' ? 'bg-gradient-to-br from-emerald-500 to-teal-600 text-theme-text-primary shadow-lg shadow-emerald-500/25' : 'text-theme-text-secondary hover:text-theme-text-primary transition-colors'}`}>
                <PlusCircle size={18} /> Registrar Día
            </button>
        ) : role === 'DEMO_USER' ? (
            <div className="bg-yellow-500/10 border border-yellow-500/20 px-4 py-2 rounded-2xl text-[10px] font-bold text-yellow-500 flex items-center gap-1.5 animate-pulse">
                <AlertTriangle size={12} /> Modo Demo Activo
            </div>
        ) : (
            <div className="bg-blue-500/10 border border-blue-500/20 px-4 py-2 rounded-2xl text-[10px] font-bold text-blue-400 flex items-center gap-1.5">
                <Info size={12} /> Modo Lector
            </div>
        )} </div> </div> {
            viewMode === 'list' && (<div className="bg-theme-panel/50 backdrop-blur-md border border-theme-border p-4 rounded-2xl mb-6 shadow-xl flex flex-col md:flex-row items-center justify-between gap-4 relative z-10"> <div className="flex items-center gap-3 text-theme-text-primary"> <Filter size={
                18
            } className="text-blue-400" /> <span className="text-sm font-semibold tracking-wide">Filtro Rango Visual:</span> </div> <div className="flex items-center gap-3 w-full md:w-auto"> <input type="date" className="bg-theme-bg border border-theme-border rounded-xl px-4 py-2 text-sm text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all font-mono" value={
                startDate
            } onChange={
                (e) => setStartDate(e.target.value)
            } /> <span className="text-theme-text-secondary font-medium font-mono">→</span> <input type="date" className="bg-theme-bg border border-theme-border rounded-xl px-4 py-2 text-sm text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all font-mono" value={
                endDate
            } onChange={
                (e) => setEndDate(e.target.value)
            } />             {(startDate || endDate) && (
                <button onClick={() => { setStartDate(''); setEndDate(''); }} className="text-sm text-theme-text-secondary hover:text-theme-text-primary ml-2 px-3 py-2 rounded-lg transition-colors font-semibold">
                    Reset
                </button>
            )} </div> </div>)
        } {
            viewMode === 'list' ? (<div className="space-y-5"> {
                logs.length === 0 ? (<div className="text-center bg-theme-panel/30 backdrop-blur-sm border border-theme-border p-16 rounded-3xl"> <ClipboardList size={
                    48
                } className="mx-auto text-slate-600 mb-4" /> <h3 className="text-xl font-bold text-theme-text-primary">No hay registros</h3> <p className="text-theme-text-secondary mt-2 font-medium">El archivo histórico se encuentra vacío para esta selección.</p> </div>) : (logs.map(log => (<div key={
                    log.id
                } className="bg-theme-panel/50 backdrop-blur-md border border-theme-border p-6 rounded-3xl flex flex-col md:flex-row justify-between md:items-center gap-6 hover:border-blue-500/30 transition-all duration-300 shadow-xl group"> <div className="space-y-4 flex-1"> <div className="flex items-center gap-4"> <span className="bg-blue-500/10 border border-blue-500/20 text-blue-400 font-mono font-bold px-3 py-1.5 rounded-lg text-sm tracking-wide"> {
                    new Date(log.log_date).toLocaleDateString()
                } </span> <span className="text-theme-text-secondary text-sm font-medium flex items-center gap-2"> <div className="w-1.5 h-1.5 0 rounded-full"></div> Redactado por: {
                    log.author_name
                } </span> </div> <p className="text-theme-text-primary text-sm md:text-base leading-relaxed line-clamp-2"> {
                    log.activities_description || 'Sin descripción pormenorizada.'
                } </p> <div className="flex flex-wrap gap-3 text-xs md:text-sm font-medium text-theme-text-secondary"> <span className="flex items-center gap-1.5 py-1 px-3 rounded-full border border-theme-border"> <CloudRain size={
                    14
                } className="text-blue-300" /> {
                        log.weather_conditions
                    } </span> <span className="flex items-center gap-1.5 py-1 px-3 rounded-full border border-theme-border"> <Thermometer size={
                        14
                    } className="text-red-300" /> {
                                    log.temperature || 'N/A'
                                } </span> <span className="flex items-center gap-1.5 py-1 px-3 rounded-full border border-theme-border"> <Users size={
                                    14
                                } className="text-emerald-300" /> {
                                    log.personnel_count
                                } Activos </span> </div> {
                            /* Mini-Galería de Imágenes */
                        } {
                            log.image_urls && log.image_urls.length > 0 && (<div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-theme-border"> {
                                log.image_urls.map((url, i) => (<a key={
                                    i
                                } href={
                                    formatImageUrl(url)
                                } target="_blank" rel="noreferrer" className="block relative w-16 h-16 rounded-xl overflow-hidden border border-theme-border hover:border-blue-400 hover:scale-105 transition-transform"> <img src={
                                    formatImageUrl(url)
                                } alt={
                                    `Evidencia ${i + 1
                                    } `
                                } className="w-full h-full object-cover" /> </a>))
                            } </div>)
                        } </div>
                    <div className="flex items-center gap-3 border-t md:border-t-0 md:border-l border-theme-border pt-4 md:pt-0 md:pl-6">
                        <button onClick={() => downloadPDF(log)} className="text-theme-text-primary hover:text-theme-text-primary transition-all duration-300 p-3 rounded-xl hover:bg-gradient-to-br hover:from-blue-600 hover:to-indigo-600 flex items-center gap-2 hover:shadow-lg hover:shadow-blue-500/25" title="Exportar Reporte Certificado">
                            <Download size={20} />
                        </button>
                        {(role === 'COMPANY_ADMIN' || role === 'SUPER_ADMIN') && (
                            <button onClick={() => handleDelete(log.id)} className="text-theme-text-secondary hover:text-theme-text-primary transition-all duration-300 p-3 rounded-xl hover:bg-gradient-to-br hover:from-red-600 hover:to-rose-600 hover:shadow-lg hover:shadow-red-500/25" title="Eliminar del Registro">
                                <Trash2 size={20} />
                            </button>
                        )}
                    </div>
                </div>
                )))}
            </div>
            ) : (
                <div className="bg-theme-panel/50 backdrop-blur-md border border-theme-border p-8 rounded-3xl shadow-xl relative z-10 animate-fade-in">
                    <h2 className="text-xl font-bold text-theme-text-primary mb-6 flex items-center gap-2">
                        <PlusCircle className="text-emerald-400" /> Nuevo Registro de Bitácora
                    </h2>
                    <form onSubmit={handleSubmit} className="space-y-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {/* Fecha */}
                            <div className="space-y-2">
                                <label className="text-theme-text-primary text-sm font-bold flex items-center gap-2 tracking-wide">
                                    <Calendar size={16} className="text-blue-400" /> Fecha del Reporte
                                </label>
                                <input type="date" name="log_date" value={formData.log_date} onChange={handleChange} required className="w-full bg-theme-bg border border-theme-border rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all font-mono" />
                            </div>

                            {/* Personal */}
                            <div className="space-y-2">
                                <label className="text-theme-text-primary text-sm font-bold flex items-center gap-2 tracking-wide">
                                    <Users size={16} className="text-emerald-400" /> Fuerza Laboral Activa
                                </label>
                                <input type="number" min="0" name="personnel_count" value={formData.personnel_count} onChange={handleChange} required placeholder="Ej. 45" className="w-full bg-theme-bg border border-theme-border rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" />
                            </div>

                            {/* Clima */}
                            <div className="space-y-2">
                                <label className="text-theme-text-primary text-sm font-bold flex items-center gap-2 tracking-wide">
                                    <CloudRain size={16} className="text-blue-400" /> Clima Predominante
                                </label>
                                <select name="weather_conditions" value={formData.weather_conditions} onChange={handleChange} className="w-full bg-theme-bg border border-theme-border rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all appearance-none">
                                    <option value="Soleado">Despejado / Soleado</option>
                                    <option value="Nublado">Mayormente Nublado</option>
                                    <option value="Lluvia Ligera">Precipitación Ligera</option>
                                    <option value="Tormenta">Tormenta / Lluvia Fuerte</option>
                                    <option value="Condiciones Extremas">Condiciones Extremas</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className="text-theme-text-primary text-sm font-bold flex items-center gap-2 tracking-wide"> <Thermometer size={16} className="text-blue-400" /> Temperatura (°C) </label>
                                <input type="text" name="temperature" value={formData.temperature} onChange={handleChange} placeholder="Ej. 28°C" className="w-full bg-theme-bg border border-theme-border rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all font-mono" />
                            </div>
                        </div >
                        <div className="space-y-2">
                            <label className="text-theme-text-primary text-sm font-bold flex items-center gap-2 tracking-wide"> <Hammer size={16} className="text-blue-400" /> Resumen de Ejecución </label>
                            <textarea name="activities_description" required rows="4" value={formData.activities_description} onChange={handleChange} placeholder="Describe el progreso físico y tareas críticas completadas..." className="w-full bg-theme-bg border border-theme-border rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all resize-none leading-relaxed" ></textarea>
                        </div>

                        <div className="space-y-2">
                            <label className="text-theme-text-secondary text-sm font-bold tracking-wide"> Maquinaria y Logística Desplegada </label>
                            <textarea name="equipment_used" rows="2" value={formData.equipment_used} onChange={handleChange} placeholder="..." className="w-full bg-theme-bg border border-theme-border rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all resize-none" ></textarea>
                        </div>

                        <div className="space-y-2 border-l-4 border-rose-500 pl-5 py-4 bg-gradient-to-r from-rose-500/10 to-transparent rounded-r-xl">
                            <label className="text-rose-400 text-sm font-bold flex items-center gap-2 tracking-wide uppercase"> Observaciones Críticas / EHS </label>
                            <textarea name="incidents_comments" rows="2" value={formData.incidents_comments} onChange={handleChange} placeholder="Cualquier desviación, incidente o nota de seguridad relevante..." className="w-full bg-theme-bg/80 border border-rose-500/20 rounded-xl px-4 py-3 text-theme-text-primary focus:outline-none focus:border-rose-500 focus:ring-1 focus:ring-rose-500 transition-all resize-none mt-2" ></textarea>
                        </div>

                        {/* Evidencia Fotográfica (Optimizada para Móvil) */}
                        <div className="space-y-4 p-5 rounded-2xl border border-theme-border border-dashed">
                            <div className="flex justify-between items-center">
                                <label className="text-theme-text-primary text-sm font-bold flex items-center gap-2 tracking-wide">
                                    <Cctv size={18} className="text-blue-400" /> Evidencia Fotográfica <span className="text-theme-text-secondary text-xs font-normal">(Max 5)</span>
                                </label>
                                <div className="relative overflow-hidden inline-block group cursor-pointer">
                                    <button type="button" className="bg-blue-600/20 hover:bg-blue-600 border border-blue-500/50 text-blue-400 hover:text-theme-text-primary px-4 py-2 rounded-xl text-xs font-bold uppercase transition-colors flex items-center gap-2 cursor-pointer">
                                        <ImageIcon size={14} /> Adjuntar Foto(s)
                                    </button>
                                    <input type="file" multiple accept="image/*" capture="environment" onChange={handlePhotoChange} className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" />
                                </div>
                            </div>
                            {photoPreviews.length > 0 && (
                                <div className="flex flex-wrap gap-4 pt-3">
                                    {photoPreviews.map((src, index) => (
                                        <div key={index} className="relative w-20 h-20 rounded-xl overflow-hidden border border-theme-border group animate-fade-in shadow-xl">
                                            <img src={src} alt="Preview" className="w-full h-full object-cover" />
                                            <button type="button" onClick={() => removePhoto(index)} className="absolute top-1 right-1 bg-theme-bg/60 backdrop-blur text-theme-text-primary p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-rose-500">
                                                <X size={12} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="pt-4 flex justify-end">
                            <button type="submit" className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-theme-text-primary font-black py-4 px-10 rounded-xl transition-all shadow-xl shadow-blue-500/20 hover:scale-[1.02] active:scale-[0.98]"> Sellar y Archivar Registro </button>
                        </div>
                    </form>
                </div>
            )}
    </div>
    );
};
export default Bitacora;
